import React from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet } from 'react-native';
import ProgressBarMinimal from '../ui/ProgressBarMinimal';
import useFakeProgress from '../../hooks/useFakeProgress';

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
    zIndex: 9999,
    elevation: 9999,
  },
});

const Loading = ({ loading, color, label, onExitAnimationComplete, fakeRatePerSecond }) => {
  const backgroundColor = color || '#000000';

  const { renderVisible, progress } = useFakeProgress({
    visible: loading,
    onExitComplete: onExitAnimationComplete,
    ...(typeof fakeRatePerSecond === 'number'
      ? {fakeRatePerSecond}
      : {}),
  });

  return renderVisible ? (
    <View style={[styles.container, { backgroundColor }]}>
      <ProgressBarMinimal progress={progress} label={label ?? 'Loading…'} />
    </View>
  ) : null;
};

Loading.propTypes = {
  loading: PropTypes.bool.isRequired,
  color: PropTypes.string,
  label: PropTypes.string,
  onExitAnimationComplete: PropTypes.func,
  fakeRatePerSecond: PropTypes.number,
};

export default Loading;
